<template>
	<div class="idle">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>我的闲具</span>
			<div @click="isDelete = true" v-if="isDelete == false">管理</div>
			<div @click="isDelete = false" v-else>完成</div>
		</div>
		<!-- 暂无数据 -->
		<div v-if="isNone" class="isNone">
			<div>您暂时还没有发布的商品哦~</div>
			<van-button size="mini" color="#F1452F" to="/Quick" round>去发布</van-button>
		</div>
		<!-- 记录列表 -->
		<div class="list" v-for="item in idleList" v-else>
			<van-checkbox v-if="isDelete == true" v-model="item.ischeck" @click="chooseChange(item.id)"
				checked-color="#f1452f" icon-size="1rem"></van-checkbox>
			<van-card>
				<div slot="thumb" class="van_img" @click="goUrl('/undeteDteil', item.id)">
					<img :src="item.image[0] | handleUrl" alt="">
				</div>
				<div slot="title" class="van_title">
					<span>{{item.title}}</span>
					<span class="active">¥{{item.price}}</span>
				</div>
				<div slot="desc" class="van_desc">
					<span>{{item.new_old}}</span>
				</div>
				<div slot="price-top" class="van_type">
					<span>{{item.province}}{{item.city}}{{item.area}}</span>
				</div>
				<div slot="price">
					<van-button size="mini" round @click="goUrl('/updateldle', item.id)">修改</van-button>
					<van-button size="mini" color="#F1452F" round>置顶</van-button>
				</div>
			</van-card>
		</div>
		<!-- 底部 -->
		<div class="settle" v-if="isDelete == true">
			<div class="all">
				<van-checkbox checked-color="#f1452f" v-model="AllChecked" @click="checkAll" icon-size="1rem">
				</van-checkbox>
				<span>全选</span>
			</div>
			<div class="settle_btn">
				<van-button size="mini" color="#F1452F" round @click="clear">删除</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		inject: ['reload'],
		data() {
			return {
				isDelete: false,
				idleList: [],
				//选中待删除商品
				selectedData: [],
				AllChecked: false,
				isNone: false
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Fta/ftaUserGoods', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code == 2) {
					for (var i = 0; i < res.data.data.length; i++) {
						res.data.data[i].ischeck = false;
					}
					this.idleList = res.data.data;
					console.log(this.idleList)
				} else {
					this.isNone = true
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			goUrl(path, id) {
				this.$router.push({
					path: path,
					query: {
						id: id
					}
				})
			},
			// 单选的change事件
			chooseChange(id) {
				if (this.selectedData.indexOf(id) > -1) {
					this.selectedData.splice(this.selectedData.indexOf(id), 1);
				} else {
					this.selectedData.push(id);
				}
				if (this.selectedData.length < this.idleList.length) {
					this.AllChecked = false;
				} else {
					this.AllChecked = true;
				}
			},
			// 全选和反选
			checkAll() {
				for (var i = 0; i < this.idleList.length; i++) {
					let list = this.idleList[i];
					if (this.AllChecked) {
						list.ischeck = false;
						this.selectedData = [];
					} else {
						list.ischeck = true;
						if (this.selectedData.indexOf(list.id) < 0) {
							this.selectedData.push(list.id);
						}
					}
				}
			},
			//删除
			clear() {
				if (this.selectedData.length != 0) {
					this.$dialog.confirm({
						message: '您确定要删除吗？'
					}).then(() => {
						this.$axios.post(baseUrl + '/mobile/Fta/ftaDelete', {
							id: this.selectedData
						}).then((res) => {
							if (res.data.code == 9) {
								this.$toast(res.data.msg);
								this.reload();
							}
						}).catch((err) => {
							console.log(err);
						})
					}).catch(() => { });
				} else {
					this.$toast('您还没有选中商品哦~');
				}
			},
		}
	}
</script>

<style scoped>
	.idle {
		padding-top: 2rem;
		overflow: hidden;
	}

	.idle .list {
		display: flex;
		background: #fff;
		margin: 0.5rem;
		border-radius: 0.5rem;
		overflow: hidden;
		box-sizing: border-box;
		position: relative;
	}

	.idle .list .van-checkbox {
		display: flex;
		justify-content: center;
		width: 1.8rem;
	}

	.idle .list .van-card {
		width: 100%;
		min-width: calc(100% - 1.8rem);
		text-align: left;
		margin-top: 0;
		background: #fff;
		padding: 0.5rem;
		height: 7rem;
	}

	.idle .list .van_title .active {
		font-size: 0.9rem;
		color: #F1452F;
		float: right;
	}

	.idle .list .van_img img {
		width: 5.5rem;
		height: 5.5rem;
		display: block;
		object-fit: cover;
		border-radius: 0.2rem;
	}

	.idle .list .van_desc {
		margin: 0.5rem 0;
	}

	.idle .list .van_desc span {
		color: #F1452F;
		padding: 0 0.2rem;
		border: 1px solid #F1452F;
		border-radius: 0.2rem;
	}

	.idle .list .van_type {
		display: flex;
		justify-content: space-between;
		color: #bfbfbf;
	}

	.idle .list .van_type span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.idle .list .van_type i {
		background: #F1452F;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.2rem;
	}

	.idle .list .van-card__price {
		color: #bfbfbf;
		width: 100%;
		text-align: right;
		margin-top: 0.2rem;
	}

	.idle .settle {
		height: 3rem;
		width: 100%;
		background: #fff;
		position: fixed;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1rem;
		box-sizing: border-box;
		font-size: 0.7rem;
		z-index: 666;
	}

	.idle .settle .all {
		display: flex;
	}

	.idle .settle .all span {
		margin-left: 0.2rem;
	}

	.idle .settle .total {
		color: #f1452f !important;
		font-size: 1rem;
	}

	.idle .settle .settle_btn button {
		outline: none;
		border: 0;
		color: #fff;
		border-radius: 1rem;
		width: 5rem;
		height: 1.5rem;
	}

	.idle .isNone {
		margin-top: 4rem;
		font-size: 0.8rem;
		color: #7D7D7D;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.idle .isNone button {
		margin-top: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/min/idle.vue